import React from 'react';
import { injectIntl } from 'react-intl';
import messages from './reportCardMessages';

import './ReportCardStudent.scss';

const ReportCardStudent = (props) => {
  let initials = props.studentName.match(/\b\w/g) || [];
  initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  return (
    <div>
      <div className="row align-items-center mb-4">
        <div className="col">
          <div className="d-flex align-items-center">
            <span className="initials inline mr-3" style={{ backgroundColor: '#D4A1DD' }}>
              {initials}
            </span>
            <div style={{ lineHeight: '1rem' }}>
              <strong>{props.studentName}</strong>
              <br />
              <span className="small">
                {props.schoolName} - {props.courseName}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col">
          <div className="card minHeight">
            <div className="card-body py-5 text-center">
              <div className="minHeightText">
                {props.intl.formatMessage(messages.classClassification)}
              </div>
              <h2 className="featured-number text-success">
                {props.positionGroupRank && `${props.positionGroupRank}º`}
              </h2>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card minHeight">
            <div className="card-body py-5 text-center">
              <div className="minHeightText">
                {props.intl.formatMessage(messages.generalClassification)}
              </div>
              <h2 className="featured-number text-success">
                {props.overallRating && `${props.overallRating}º`}
              </h2>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card minHeight">
            <div className="card-body py-5 text-center">
              <div className="minHeightText">{props.intl.formatMessage(messages.schoolGrade)}</div>
              <h2 className="featured-number text-success">
                {props.schoolHits && props.schoolHits}
              </h2>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card minHeight">
            <div className="card-body py-5 text-center">
              <div className="minHeightText">{props.intl.formatMessage(messages.percentage)}</div>
              <h2 className="featured-number text-success">
                {props.percentHit && `${props.percentHit}%`}
              </h2>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card minHeight">
            <div className="card-body py-5 text-center">
              <div className="minHeightText">{props.intl.formatMessage(messages.participants)}</div>
              <h2 className="featured-number">{props.countStudents && props.countStudents}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ReportCardStudent.propTypes = {};

ReportCardStudent.defaultProps = {
  positionGroupRank: '',
  overallRating: '',
  schoolHits: '',
  percentHit: '',
  countStudents: '',
  studentName: '',
};

export default injectIntl(ReportCardStudent);
